import { render, staticRenderFns } from "./ProductBottom.vue?vue&type=template&id=c89c34fe&scoped=true&"
import script from "./ProductBottom.vue?vue&type=script&lang=js&"
export * from "./ProductBottom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c89c34fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c89c34fe')) {
      api.createRecord('c89c34fe', component.options)
    } else {
      api.reload('c89c34fe', component.options)
    }
    module.hot.accept("./ProductBottom.vue?vue&type=template&id=c89c34fe&scoped=true&", function () {
      api.rerender('c89c34fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/product/ProductBottom.vue"
export default component.exports